import React, { lazy } from "react";

export class RouteConstants {
  static PatientDetailContainer = lazy(
    () =>
      import(
        /* webpackChunkName: "PatientDetail" */ "../layout/PatientDetailLayout"
      )
  );

  // Define module routes for the patients module
  static readonly MODULE_ROUTES = [
    {
      path: "/patients/:id", // URL path for the patients list
      //component: RouteConstants.PatientModuleProvider, // Component to render for this route
      component: React.createElement(RouteConstants.PatientDetailContainer), // Component to render for this route
      actionName: "view", // Action name associated with this route
      displayName: "Patients List", // Display name for the route
      isMenu: false, // Indicates if this route should be shown in the menu
    },
  ];
}
